import React from 'react';
import gaLogger from 'src/utils/ga-logger';
import Slider, { Settings }  from 'react-slick';
import { SlickCarouselProps } from '../typings';
import { checkValue } from 'src/components/common/helper';

export const MediaStudioSlickSlider = (props: SlickCarouselProps) => {
  const { children, settings, gaTracking } = props;

  let slickSettings: Settings = {
    arrows: true,
    variableWidth: true,
    slidesToScroll: 3,
    slidesToShow: 1,
    centerPadding: '0px',
    infinite: false,
    initialSlide: 0,
    lazyLoad: 'progressive',
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: true,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 766,
        settings: {  
          dots: true, 
        },
      },
      {
        breakpoint: 560,
        settings: {   
          dots: true,  
          slidesToShow: 1,
        },
      },
    ],
  };
  if(checkValue(settings)){
    slickSettings = settings;
  }  
  const onSlickChange = (currentSlide: number) => {
    if(checkValue(gaTracking)){
      const { eventCategory, eventAction, eventLabel } = gaTracking;
      gaLogger.logGa(eventCategory, eventAction, eventLabel + currentSlide);
    }    
  };

  slickSettings.afterChange = onSlickChange;

  return (
    <div className="common-media-carousel-module"> 
      <Slider {...slickSettings}>{children}</Slider>
    </div>
  );
};
